"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DOMHelper = void 0;
/**
 * @description Find out if obj is an HTMLElement
 * @returns true if obj is HTMLElement, if not false
 */
function isHtmlElement(obj) {
  return obj != null && obj.style !== undefined;
}
/**
 * @description Create HTMLElement
 * @param type Element type for the new HTMLElement (div,span,h1,...)
 * @param parent HTMLElement parent in DOM for the new HTMLElement
 * @param elementId Element id for the new HTMLElement
 * @param classname Element class for the new HTMLElement
 * @param content Some text for the new HTMLElement
 * @returns the created HTMLElement
 */
var createElementWithParent = function (type, parent, elementId, classname, content) {
  var _a;
  if (parent === void 0) {
    parent = null;
  }
  if (elementId === void 0) {
    elementId = null;
  }
  if (classname === void 0) {
    classname = null;
  }
  if (content === void 0) {
    content = null;
  }
  var element = document.createElement(type);
  if (elementId != null) element.id = elementId;
  if (classname != null) element.className = classname;
  if (parent != null) parent.appendChild(element);
  else (_a = document.getElementById("hidden")) === null || _a === void 0 ? void 0 : _a.appendChild(element);
  if (content != null) element.innerHTML += content;
  return element;
};
/**
 * @description Used to build page.
 */
exports.DOMHelper = {
  /**
   * @description Find the first HTMLElement with spedcified className
   * @param className HTMLElement classname that you want to find
   * @returns HTMLElement if found, if not throw an error
   * @throws "no HTML element found for classname {className}"
   */
  firstElementByClassName: function (className) {
    var element = document.getElementsByClassName(className).item(0);
    if (isHtmlElement(element)) {
      return element;
    } else {
      throw "no HTML element found for classname " + className;
    }
  },
  /**
   * @description Get the head HTMLElement
   * @returns HTMLElement if found, if not throw an error
   * @throws "no head"
   */
  getHead: function () {
    var head = document.getElementsByTagName("head").item(0);
    if (!head) throw "no head!";
    return head;
  },
  /**
   * @description Get the body HTMLElement
   * @returns HTMLElement if found, if not throw an error
   * @throws "no body"
   */
  getBody: function () {
    var body = document.getElementsByTagName("body").item(0);
    if (!body) throw "no body!";
    return body;
  },
  /*
   * GENERAL FUNCTIONS
   */
  /**
   * @description Give a new className to your HTMLElement (only if className was null on this Element)
   * @param element HTMLElement to edit
   * @param classname the classname to add
   */
  addClass: function (element, classname) {
    if (element && !element.classList.contains(classname)) {
      element.classList.add(classname);
    }
  },
  /**
   *@description Remove HTMLElement className
   *@param element HTMLElement to edit
   * @param classname the classname to remove
   */
  removeClass: function (element, classname) {
    if (element && element.classList.contains(classname)) {
      element.classList.remove(classname);
    }
  },
  /**
   *@description Find out if HTMLElement have the specified classname
   *@param element HTMLElement to test
   *@param className classname to test
   */
  hasClass: function (element, classname) {
    if (element && !element.classList.contains(classname)) {
      return false;
    }
    return true;
  },
  /**
   * @description Create <div> HTMLElement in the specified parent with specified parameters
   * @param parent HTMLElement parent in DOM
   * @param elementId id for new HTMLElement
   * @param className className for new HTMLElement
   * @param content content for new HTMLElement
   * @returns the HTMLElement builded
   */
  createFirstDivWithParent: function (parent, elementId, classname, content) {
    var element = document.createElement("div");
    if (elementId != null) element.id = elementId;
    if (classname != null) element.className = classname;
    if (parent != null) parent.insertBefore(element, parent.childNodes[0]);
    if (content != null) element.innerHTML += content;
    return element;
  },
  createElementWithParent: createElementWithParent,
  /**
   * @description create HTMLElement with div type
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param elementId Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement
   * @param content Some text for the new HTMLElement
   * @returns the create HTMLElement
   */
  createDivWithParent: function (parent, elementId, classname, content) {
    if (parent === void 0) {
      parent = null;
    }
    if (elementId === void 0) {
      elementId = null;
    }
    if (classname === void 0) {
      classname = null;
    }
    if (content === void 0) {
      content = null;
    }
    return createElementWithParent("div", parent, elementId, classname, content);
  },
  /**
   * @description create HTMLElement with source type
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param elementId Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement
   * @param content Some text for the new HTMLElement
   * @returns the create HTMLElement
   */
  createSourceWithParent: function (parent, elementId, classname, content) {
    if (parent === void 0) {
      parent = null;
    }
    if (elementId === void 0) {
      elementId = null;
    }
    if (classname === void 0) {
      classname = null;
    }
    if (content === void 0) {
      content = null;
    }
    return createElementWithParent("source", parent, elementId, classname, content);
  },
  /**
   * @description create HTMLElement with span type
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param elementId Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement
   * @param content Some text for the new HTMLElement
   * @returns the create HTMLElement
   */
  createSpanWithParent: function (parent, elementId, classname, content) {
    if (parent === void 0) {
      parent = null;
    }
    if (elementId === void 0) {
      elementId = null;
    }
    if (classname === void 0) {
      classname = null;
    }
    if (content === void 0) {
      content = null;
    }
    return createElementWithParent("span", parent, elementId, classname, content);
  },
  /**
   * @description create HTMLElement with p type
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param elementId Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement
   * @param content Some text for the new HTMLElement
   * @returns the create HTMLElement
   */
  createTextWithParent: function (parent, elementId, classname, content) {
    return createElementWithParent("p", parent, elementId, classname, content);
  },
  /**
   * @description create HTMLElement with div type and an image background with backgroud-repeat : no-repeat && background size : contain
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param idElement Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement (will add " img" at end. Ex: <div class='sample img'>)
   * @param src image file source.
   * @param size define image size
   * @returns the create HTMLElement
   */
  createDivImg: function (parent, idElement, classname, src, size) {
    if (classname === void 0) {
      classname = null;
    }
    if (src === void 0) {
      src = null;
    }
    if (size === void 0) {
      size = null;
    }
    var element = document.createElement("div");
    classname ? (classname += " img") : (classname = "img");
    if (idElement != null) element.id = idElement;
    if (classname != null) element.className = classname;
    // PERF: this adds a listener on each & every image. Expensiveness? Benefits?
    // element.onerror = () => {
    //   element.style.display = "none";
    // };
    if (src) {
      element.style.background = "url(" + src + ") no-repeat";
      element.style.backgroundSize = "cover";
      if (size) {
        element.style.width = size.width.toString();
        element.style.height = size.height.toString();
      }
    }
    if (parent) {
      parent.appendChild(element);
    }
    return element;
  },
  /**
   * @description create HTMLElement with img type and an image
   * @param parent HTMLElement parent in DOM for the new HTMLElement
   * @param idElement Element id for the new HTMLElement
   * @param classname Element class for the new HTMLElement (will add " img" at end. Ex: <div class='sample img'>)
   * @param src image file source.
   * @param size define image size
   * @returns the create HTMLElement
   */
  createImg: function (parent, idElement, classname, src) {
    if (classname === void 0) {
      classname = null;
    }
    if (src === void 0) {
      src = null;
    }
    var element = document.createElement("img");
    // classname ? (classname += " img") : (classname = "img");
    element.style.backgroundColor = "#444";
    if (idElement != null) element.id = idElement;
    if (classname != null) element.className = classname;
    // PERF: this adds a listener on each & every image. Expensiveness? Benefits?
    // element.onerror = () => {
    //   element.style.display = "none";
    // };
    element.onload = function () {
      console.warn(idElement + " loaded and is " + element.naturalWidth + "x" + element.naturalHeight);
      delete element.onload;
    };
    if (src) {
      element.style.objectFit = "cover";
      element.src = src;
    }
    if (parent) {
      parent.appendChild(element);
    }
    return element;
  },
};
//# sourceMappingURL=DOMHelper.js.map
